import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps } from '@mui/material';

export const Checkbox = MuiCheckbox;
export type CheckboxProps = MuiCheckboxProps;
